<template>
  <div class="form-element -nobottom">
    <label class="form-element__title -nomargin" v-if="title">{{
      title
    }}</label>
    <div class="form-element__multiselect ">
      <form-select
        class="-auto " 
        :placeholder="'Gün'"
        :list="days"
        v-model="form.day"
        :isDay="true"
        :class="{ '-SelectError': isError}"
      />
      <form-select
        class="-auto"
        :placeholder="'Ay'"
        :list="months"
        v-model="form.month"
        :isMonth="true"
        :class="{ '-SelectError': isError}"
      />
      <form-select
        class="-auto"
        :placeholder="'Yıl'"
        :list="filteredYears"
        v-model="form.year"
        :isDay="true"
        :class="{ '-SelectError': isError}"
      />
    </div>
    <div class="form-element__message" v-if="message">{{ message }}</div>
    <div
      class="form-element__message"
      :class="{ '-error': isError }"
      v-if="message2"
      style="color:red"
    >
      {{ message2 }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Date,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    message: {
      type: String,
      default: null,
    },
    message2: {
      type: String,
      default: null,
    },
    filterList: {
      type: Boolean,
      default: false,
    },
    isError:{
      type: Boolean,
      default: false,
    },
    startYear: {
      type: Number,
      default: 1990,
    },
  },
  data() {
    return {
      form: {
        day: null,
        month: null,
        year: null,
      },
      days: [
        { id: 1, name: "1", value: "01" },
        { id: 2, name: "2", value: "02" },
        { id: 3, name: "3", value: "03" },
        { id: 4, name: "4", value: "04" },
        { id: 5, name: "5", value: "05" },
        { id: 6, name: "6", value: "06" },
        { id: 7, name: "7", value: "07" },
        { id: 8, name: "8", value: "08" },
        { id: 9, name: "9", value: "09" },
        { id: 10, name: "10", value: "10" },
        { id: 11, name: "11", value: "11" },
        { id: 12, name: "12", value: "12" },
        { id: 13, name: "13", value: "13" },
        { id: 14, name: "14", value: "14" },
        { id: 15, name: "15", value: "15" },
        { id: 16, name: "16", value: "16" },
        { id: 17, name: "17", value: "17" },
        { id: 18, name: "18", value: "18" },
        { id: 19, name: "19", value: "19" },
        { id: 20, name: "20", value: "20" },
        { id: 21, name: "21", value: "21" },
        { id: 22, name: "22", value: "22" },
        { id: 23, name: "23", value: "23" },
        { id: 24, name: "24", value: "24" },
        { id: 25, name: "25", value: "25" },
        { id: 26, name: "26", value: "26" },
        { id: 27, name: "27", value: "27" },
        { id: 28, name: "28", value: "28" },
        { id: 29, name: "29", value: "29" },
        { id: 30, name: "30", value: "30" },
        { id: 31, name: "31", value: "31" },
      ],
      months: [
        {
          id: 1,
          name: "Ocak",
          value: "01",
        },
        {
          id: 2,
          name: "Şubat",
          value: "02",
        },
        {
          id: 3,
          name: "Mart",
          value: "03",
        },
        {
          id: 4,
          name: "Nisan",
          value: "04",
        },
        {
          id: 5,
          name: "Mayıs",
          value: "05",
        },
        {
          id: 6,
          name: "Haziran",
          value: "06",
        },
        {
          id: 7,
          name: "Temmuz",
          value: "07",
        },
        {
          id: 8,
          name: "Ağustos",
          value: "08",
        },
        {
          id: 9,
          name: "Eylül",
          value: "09",
        },
        {
          id: 10,
          name: "Ekim",
          value: "10",
        },
        {
          id: 11,
          name: "Kasım",
          value: "11",
        },
        {
          id: 12,
          name: "Aralık",
          value: "12",
        },
      ],
      years: this.generateYears(this.startYear),
    };
  },
  watch: {
    form: {
      deep: true,
      handler: "isChange",
    },
  },
  computed: {
    filteredYears: function () {
      if (this.filterList) return this.years.filter((item) => item.id > 100);

      return this.years;
    },
  },
  methods: {
    generateYears: function (startYear) {
      const now = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth(); // 0-11
      const currentDay = now.getDate();
      
      // Eğer 31 Aralık ise yıla +1 ekle
      const endYear = (currentMonth === 11 && currentDay === 31) 
        ? currentYear + 1 
        : currentYear;
      
      const years = [];
      const safeStartYear = Number.isFinite(startYear) ? startYear : 1990;
      
      for (let year = safeStartYear; year <= endYear; year++) {
        years.push({
          id: year - safeStartYear + 1,
          name: year.toString()
        });
      }
      
      return years;
    },
    isChange: function () {
      let vm = this;

      if (!vm.form.day || !vm.form.month || !vm.form.year)
        return vm.$emit("input", null);

      let month = vm.months.find((item) => item.name == vm.form.month).value;
      let day = vm.days.find((item) => item.name == vm.form.day).value;

      let date = `${month}-${day}-${vm.form.year}`;

      let s = new Date(date).valueOf();
      // let d = new Date(s + 0)
      let d = new Date(s + 10800000);

      return vm.$emit("input", d);
    },
  },
};
</script>
